import { z } from "zod";

export const residentialAuditSearchSchema = z.object({
  locationId: z.string().min(1),
  auditDate: z.date(),
});
